<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-12">
                <h3 v-html="stepTitle" class="cursor-pointer d-flex align-items-center" @click="setAction()"></h3>
            </div>
            <div class="col-md-6 col-xl-5 pos-r-lg-max">
                <FormCheckPrice
                    :tmpCheckPrice="tmpCheckPrice" 
                    :countries="countries"
                    :listSize="listSize" 
                    @getListCourier="getListCourier"
                    @getListCourierInter="getListCourierInter"
                />
            </div>
            <div class="col-md-6 col-xl">
                <TableCourierCheckPrice 
                    ref="checkPrice"
                    :tmpCheckPrice="tmpCheckPrice"
                    @selectedCourier="$emit('courierCheckPrice' , $event )"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FormCheckPrice from '@/components/custom/pos/FormCheckPrice';
import TableCourierCheckPrice from '@/components/custom/pos/TableCourierCheckPrice';
import { getCourierCheckPrice , getIcon } from "@/axios/pos.js";
import { showErrorModal } from "@/components/modalNotification.js";
import { 
    getStepPage
} from "@/plugins/posHelper.js";

export default {
    props:{
        tmpCheckPrice: Object,
        posPage: Object,
        listSize: Object,
        sameData: Object,
        busy: Boolean,
    },
    data() {
        return {
            countries: [],
            mockArrayCourier: [],
            isBusy: this.busy,
        }
    },
    components:{
        FormCheckPrice,
        TableCourierCheckPrice
    },
    mounted(){
        this.setDefaultAddressFrom()
        this.getCountryCode()
    },
    methods:{
        async getListCourierInter() {
            this.tmpCheckPrice.isLoading = true;
            const idCountry = this.tmpCheckPrice.toINTER.id
            const countries = this.countries.find(res => idCountry === res.id)
            const bodyJson = {
                weight: parseFloat(this.tmpCheckPrice.weight),
                height: parseFloat(this.tmpCheckPrice.dimension.height),
                length: parseFloat(this.tmpCheckPrice.dimension.length),
                width: parseFloat(this.tmpCheckPrice.dimension.width),
                country_code: countries.alpha_2_code,
                show_all: true
            }

            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            await this.$http.post(this.$API_URL + '/inter/checkprice/optional', bodyJson, headers).then((res) => {
                const courierData = res.data.data
                courierData.forEach((data) => {
                    let mockData = {
                        "status": Number(data.summary_of_service_and_price) > 0 ? true : false,
                        "courier_id": data.id,
                        "courier_code": countries.alpha_2_code === "LA" ? "LAO" : "INT",
                        "courier_key": data.courier_code,
                        "courier_name": data.name,
                        "price": Number(data.summary_of_service_and_price),
                        "service_price_inter": Number(data.service_shop),
                        "remote_area": 0,
                        "travel_surcharge": 0,
                        "island_surcharge": 0,
                        "fuel_surcharge": 0,
                        "src": data.logo_url
                    }
                    this.mockArrayCourier.push(mockData)
                })
                this.$refs.checkPrice.listCourier = []
            }).finally(() => {
                this.$refs.checkPrice.listCourier = this.mockArrayCourier
                this.mockArrayCourier = [];
                this.tmpCheckPrice.isLoading = false;
            })
        },
        async getCountryCode() {
            this.busy = true
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            await this.$http.get(this.$API_URL + '/inter/all/country', headers).then((res) => {
                this.countries = res.data.data.countries
            }).finally(() => {
                this.busy = false
            })
        },
        changeStepPage(){
            this.posPage.step = getStepPage.STEP_PAGE_FIRST
        },
        setAction(){
            this.$emit('clearDataTmpCheckPrice')
            this.changeStepPage();
        },
        getListCourier(){
            this.tmpCheckPrice.isLoading = true;
            getCourierCheckPrice(this.tmpCheckPrice).then( async (resCourier) => {
                
                this.$refs.checkPrice.listCourier = resCourier.sort( (a,b) => { 
                    return (a.status===false)-(b.status===false) 
                    || (Number(a.price)===0)-(Number(b.price)===0) 
                    || Number(a.price) - Number(b.price)
                })

                this.$refs.checkPrice.listCourier.forEach( async(courier , index) => {
                    this.$set(resCourier[index], 'src' , 'img/brand/load-error.svg')
                    await getIcon( courier.courier_icon ).then( res => {
                        this.$set(resCourier[index], 'src' , res)
                    })
                });

                // await Promise.all(resCourier.map(async (courier , index) => {
                //     await getIcon( courier.courier_icon ).then( res => {
                //         this.$set(resCourier[index], 'src' , res)
                //     })
                // }));

                this.tmpCheckPrice.isLoading = false;
            }).catch(e => {
                showErrorModal(e)
                this.tmpCheckPrice.isLoading = false;
            });
        },
        setDefaultAddressFrom(){
            this.tmpCheckPrice.fromAddress.district = this.sameData.state
            this.tmpCheckPrice.fromAddress.state = this.sameData.district
            this.tmpCheckPrice.fromAddress.province = this.sameData.province
            this.tmpCheckPrice.fromAddress.postcode = this.sameData.postcode
        }
    },
    computed:{
        stepTitle(){
            let text = '';
                text = '<i class="fas fa-angle-left pr-1"></i> ย้อนกลับ';
            return text;
        }
    }
}
</script>